import {ScorecardRow} from "./row";
import {PenaltiesRow} from "../model/participant-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";

export function getPenaltiesRow(row: PenaltiesRow): ScorecardRow {
    return {
        name: "Pen",
        outValues: row.data.outValues,
        outTotal: row.data.outTotal,
        inValues: arrayOrEmpty(row.data.inValues),
        inTotal: row.data.inTotal,
        total: row.data.total,
        classes: "penalties"
    };
}
